var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47781 39.4141V36.7308M3.11133 39.4141V36.7308",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79462 32.4691C7.18935 32.4691 8.32001 31.3385 8.32001 29.9438C8.32001 28.549 7.18935 27.4184 5.79462 27.4184C4.39988 27.4184 3.26923 28.549 3.26923 29.9438C3.26923 31.3385 4.39988 32.4691 5.79462 32.4691Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.585938 38.2656V39.414H11.0031V34.9945C11.0031 33.6 9.87266 32.4695 8.47812 32.4695H3.11172C1.71641 32.4695 0.585938 33.6 0.585938 34.9945V35.5234M36.8887 12.5816V9.89835M31.5222 12.5816V9.89835",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2054 5.63672C35.6001 5.63672 36.7308 4.50606 36.7308 3.11133C36.7308 1.71659 35.6001 0.585938 34.2054 0.585938C32.8106 0.585938 31.68 1.71659 31.68 3.11133C31.68 4.50606 32.8106 5.63672 34.2054 5.63672Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4141 11.6062V12.5812H28.9969V8.1625C28.9969 6.76719 30.1273 5.63672 31.5219 5.63672H36.8883C38.2836 5.63672 39.4141 6.76719 39.4141 8.1625V8.86406M8.47781 12.5816V9.89836M3.11133 12.5816V9.89836",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79462 5.63672C7.18935 5.63672 8.32001 4.50606 8.32001 3.11133C8.32001 1.71659 7.18935 0.585938 5.79462 0.585938C4.39988 0.585938 3.26923 1.71659 3.26923 3.11133C3.26923 4.50606 4.39988 5.63672 5.79462 5.63672Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8887 39.4141V36.7308M31.5222 39.4141V36.7308M11.0032 12.5817H0.585938V8.1622C0.585938 6.76744 1.71656 5.63681 3.11133 5.63681H8.47781C9.87258 5.63681 11.0032 6.76744 11.0032 8.1622V12.5817Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2054 32.4691C35.6001 32.4691 36.7308 31.3385 36.7308 29.9438C36.7308 28.549 35.6001 27.4184 34.2054 27.4184C32.8106 27.4184 31.68 28.549 31.68 29.9438C31.68 31.3385 32.8106 32.4691 34.2054 32.4691Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9953 14.1344C17.1351 13.3539 18.5148 12.8976 20 12.8976C23.9226 12.8976 27.1023 16.0773 27.1023 20C27.1023 23.9226 23.9226 27.1023 20 27.1023C16.0773 27.1023 12.8976 23.9226 12.8976 20C12.8976 18.5539 13.3297 17.2086 14.0726 16.0867M39.4141 39.4141H28.9968V34.9946C28.9968 33.5998 30.1274 32.4692 31.5222 32.4692H36.8887C38.2834 32.4692 39.4141 33.5999 39.4141 34.9946V39.4141Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.1568C21.7434 23.1568 23.1568 21.7434 23.1568 20C23.1568 18.2565 21.7434 16.8432 20 16.8432C18.2565 16.8432 16.8432 18.2565 16.8432 20C16.8432 21.7434 18.2565 23.1568 20 23.1568Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerIcon);
export default __webpack_public_path__ + "static/media/player-icon.f251c1c49aa0dfa08b17f11098411d48.svg";
export { ForwardRef as ReactComponent };